import React from 'react';
import NumberFormat from 'react-number-format';

export const NumberFormatCustomHundred = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isAllowed={(values) => {
                const { formattedValue, floatValue, value } = values;
                const regex = RegExp(/\d*\./);
                //console.log('regex: ', regex);
                const includingPeriod = regex.test(value);
                let appropriateNum = false;
                if (!includingPeriod && (floatValue <= 9999)) {
                    //console.log('includeing period: ', includingPeriod);
                    appropriateNum = true; 
                }
                return formattedValue === "" || appropriateNum;
            }}
            thousandSeparator
            isNumericString
            allowNegative={false}
            suffix=" 百万円"
        />
    );
}

export const NumberFormatCustom = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isAllowed={(values) => {
                const { formattedValue, floatValue, value } = values;
                const regex = RegExp(/\d*\./);
                //console.log('regex: ', regex);
                const includingPeriod = regex.test(value);
                let appropriateNum = false;
                if (!includingPeriod && (floatValue <= 9999)) {
                    //console.log('includeing period: ', includingPeriod);
                    appropriateNum = true; 
                }
                return formattedValue === "" || appropriateNum;
            }}
            thousandSeparator
            isNumericString
            allowNegative={false}
            suffix=" 万円"
        />
    );
}

export const NumberFormatCustomFiveDigits = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isAllowed={(values) => {
                const { formattedValue, floatValue, value } = values;
                const regex = RegExp(/\d*\./);
                //console.log('regex: ', regex);
                const includingPeriod = regex.test(value);
                let appropriateNum = false;
                if (!includingPeriod && (floatValue <= 99999)) {
                    //console.log('includeing period: ', includingPeriod);
                    appropriateNum = true; 
                }
                return formattedValue === "" || appropriateNum;
            }}
            thousandSeparator
            isNumericString={true}
            allowNegative={false}
            suffix=" 万円"
        />
    );
}